var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.681641,
    width: 20,
    height: 16.6364,
    rx: 8,
    fill: "#D7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6528 3.09069C10.5324 2.84071 10.2779 2.68164 9.99837 2.68164C9.71885 2.68164 9.46661 2.84071 9.34389 3.09069L7.88269 6.09718L4.6194 6.57895C4.3467 6.61985 4.11945 6.81074 4.03537 7.07208C3.95129 7.33342 4.01946 7.62202 4.2149 7.81518L6.58282 10.1581L6.02379 13.4691C5.97834 13.7418 6.09197 14.0191 6.31694 14.1804C6.54192 14.3418 6.83961 14.3622 7.08504 14.2327L10.0006 12.676L12.9162 14.2327C13.1617 14.3622 13.4594 14.344 13.6843 14.1804C13.9093 14.0168 14.0229 13.7418 13.9775 13.4691L13.4162 10.1581L15.7841 7.81518C15.9795 7.62202 16.05 7.33342 15.9636 7.07208C15.8773 6.81074 15.6523 6.61985 15.3796 6.57895L12.114 6.09718L10.6528 3.09069Z",
    fill: "#007AEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneStar);
export default __webpack_public_path__ + "static/media/one_star.3a4a1a5f01a1f53737e1b158cc8253ea.svg";
export { ForwardRef as ReactComponent };